
export const getOrderBooks = () => ({
  method: 'get',
  url: 'Trade/OrderBooks/',
});
